import { theme, formatMoney } from './global.js';

const modal = () => document.getElementById('quick-view-modal');

document.addEventListener('click', async (e) => {
  const trigger = e.target.closest('[data-quick-view-trigger]');
  if (!trigger) return;
  e.preventDefault();
  const url = trigger.dataset.productUrl;
  const content = modal()?.querySelector('[data-quick-view-content]');
  if (!content || !url) return;

  content.innerHTML = `<div class="spinner" role="status"><span class="visually-hidden">${theme.strings.loading || 'Loading...'}</span></div>`;
  modal()?.open(trigger);

  try {
    const res = await fetch(`${url}.js`);
    const product = await res.json();
    content.innerHTML = renderQuickView(product);
  } catch (err) {
    content.innerHTML = `<p>${theme.strings.cartError || 'Something went wrong'}</p>`;
  }
});

function renderQuickView(product) {
  const variant = product.variants.find((v) => v.available) || product.variants[0];
  const optionHtml = product.options
    .map(
      (name, i) => `
      <label class="field-label">${name}</label>
      <select class="field quick-view__option" data-option-index="${i}">
        ${[...new Set(product.variants.map((v) => v[`option${i + 1}`]))]
          .map((value) => `<option value="${value}" ${value === variant[`option${i + 1}`] ? 'selected' : ''}>${value}</option>`)
          .join('')}
      </select>`
    )
    .join('');

  return `
    <div class="quick-view">
      <div class="quick-view__media">
        <img src="${product.featured_image ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') : ''}" alt="${product.title}" width="300" height="300" loading="lazy">
      </div>
      <div class="quick-view__info">
        <h2 class="h3">${product.title}</h2>
        <p class="quick-view__price">${formatMoney(variant.price, theme.moneyFormat)}</p>
        <form data-type="add-to-cart-form" data-quick-view-form>
          <input type="hidden" name="id" value="${variant.id}" data-quick-view-variant-id>
          ${optionHtml}
          <div class="quick-view__actions">
            <button type="submit" class="btn btn--primary btn--full" ${variant.available ? '' : 'disabled'}>
              ${variant.available ? (theme.strings.addToCart || 'Add to cart') : (theme.strings.soldOut || 'Sold out')}
            </button>
            <a href="${product.url}" class="btn btn--outline btn--full">${theme.strings.viewFullDetails || 'View full details'}</a>
          </div>
        </form>
      </div>
    </div>`;
}

document.addEventListener('change', (e) => {
  const select = e.target.closest('.quick-view__option');
  if (!select) return;
  const form = select.closest('form');
  const selects = Array.from(form.querySelectorAll('.quick-view__option'));
  const chosen = selects.map((s) => s.value);
  const url = new URL(form.closest('.quick-view').querySelector('a.btn--outline').href, window.location.origin);
  fetch(`${url.pathname}.js`)
    .then((r) => r.json())
    .then((product) => {
      const match = product.variants.find((v) => chosen.every((val, i) => v[`option${i + 1}`] === val));
      if (match) {
        form.querySelector('[data-quick-view-variant-id]').value = match.id;
        const priceEl = form.closest('.quick-view__info').querySelector('.quick-view__price');
        priceEl.textContent = formatMoney(match.price, theme.moneyFormat);
        const submit = form.querySelector('[type="submit"]');
        submit.disabled = !match.available;
        submit.textContent = match.available ? theme.strings.addToCart || 'Add to cart' : theme.strings.soldOut || 'Sold out';
      }
    });
});

